module.exports = __webpack_public_path__ + "img/9791156751601.d7a1f755.jpg";